// eslint-disable-next-line import/no-cycle
import merchy from './merchy';

export default {
  merchy,
};
